export default __webpack_public_path__ + "static/media/art-pro-blk-4.27ea418f.png";